import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';
import { creditWeiCost, smartContractAddress, availableEntryFees, baseURL } from '../util/Constants.js';

import { useGamesData } from '../hooks/useGamesData.js';
import { availableGames } from '../util/AvailableGames.js';

import Select from '@material-ui/core/Select';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { useGamerData } from '../hooks/useGamerData';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
    '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(16),
      },
  },
  paper: {
    padding: theme.spacing(4),
    margin: theme.spacing(4),
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: '#FFFFFF',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

export const CreateContest = (props) => {

  const { account, library } = useWeb3React();
  const gamerData = useGamerData( account );

  const [hasInit, setHasInit] = useState(false);
  const [myContract, setMyContract] = useState(null);

  const [gameValue, setGameValue] = useState("");
  const [maxPlayersCurrentGame, setMaxPlayersCurrentGame] = useState(null);
  const [maxPlayersContest, setMaxPlayersContest] = useState(2);
  const [entryFeeValue, setEntryFeeValue] = useState(0);

  const [goal, setGoal] = useState(null);
  const [goalDesc, setGoalDesc] = useState(null);

  const gamesData = useGamesData();

  const classes = useStyles();

  useEffect(() => {

    if(props.gameValue && gameValue !== props.gameValue){
        setGameValue(props.gameValue);
    }

  },[props.gameValue])

  useEffect(() => {
    if(library && !hasInit){
      const contract = new Contract(smartContractAddress, GFCABI, library.getSigner());
      setMyContract(contract);
      setHasInit(true);
    }
    
  },[library])

  useEffect(() => {

      if(gamesData.data){
          console.log(`gamesData.data`, gamesData.data);
      }

  },[gamesData.data])

  useEffect(() => {

      if(gamesData.maxPlayersData){
          console.log(`gamesData.maxPlayersData`, gamesData.maxPlayersData);
      }

  },[gamesData.maxPlayersData])

  const refreshEvents = () => {
 
    let fetchURL = `${baseURL}/checkContractEvents`;
  
    fetch(fetchURL,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((res) => {
          console.log('completed refreshEvents');
        })
    }

  const handleSetGameValue = (game) => {
      if(props.selectGame){
          props.selectGame(game);
      } else {
          setGameValue(game);
      }
  }

  const getSmartContractIndex = (contestID) => {

      if(myContract !== null){
      console.log(myContract, contestID);

      myContract['getContestIndex'](contestID)
      .then(result => {
        console.log(`ContestID`, result);
      })

    }

  }

  const addContestToSmartContract = (contestID) => {

    //let gamer = gamerData.hasGamerName;

      if(myContract !== null){
      console.log(myContract, contestID);

      myContract['createContest'](gameValue, entryFeeValue, maxPlayersContest, contestID)
      .then(result => {
        console.log(`Added To Smart Contract`, result);
        getSmartContractIndex(contestID);
        refreshEvents();
      })

      
    }

  }

  const createContestLocal =  () => {
        //gameValue, entryFeeValue, maxPlayersContest

        let postData = {
            gameName: gameValue,
            entryFee: entryFeeValue,
            maxPlayers: maxPlayersContest,
            address: account,
            goal: goal,
            goalDesc: goalDesc,
        }
    
        let fetchURL = `${baseURL}/createGamingContest`;

        console.log(`Post Data:`, postData);
    
        fetch(fetchURL,
            {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        .then((res) => {
            let retData = res.json();
    
            console.log(retData);
    
            retData.then((data) => {

                console.log('Inside ');
                console.log(data);

                addContestToSmartContract(data.contestID);
    
            })
        })
    }

  const attemptCreateContest = () => {
    console.log('Attempt..', account);

    createContestLocal();

    return null;

    
  }

  const displayGamesSelect = () => {
      let display = null;
      let entries = null;

        if(gamesData.data) {
            entries = gamesData.data.map((gameData) => {
                return(
                    <option value={gameData.name}>{gameData.name}</option>
                )
            })
        }

        if(entries !== null){
            let emptySelect = (
                <option value="-"> Please Select Game </option>
            )
            entries.unshift(emptySelect);

            display = (
                <React.Fragment>
                <InputLabel shrink>
                 Game
                </InputLabel>
                <Select value={gameValue}
                onChange={(event) => {
                   handleSetGameValue(event.target.value);
                }}
                >
                    {entries}
                </Select>
                </React.Fragment>
            )
        }

      return display;
  }

  const displayGameMaxPlayers = () => {
      let display = null;
      let displayMax = 0;

      if(gameValue !== ""){
          if(gamesData && gamesData.maxPlayersData && gamesData.maxPlayersData[gameValue]){
          displayMax = gamesData.maxPlayersData[gameValue];
          }
      }

      if(displayMax !== 0){
          display = (
              <p> Max Players (Game Limit): {displayMax} </p>
          )
      }

      return display;
  }

  const displayContestMaxPlayers = () => {
    let display = null;
    
    display = (
        <div>        
        <TextField id={"standard-basic"} value={maxPlayersContest} label={"Max Players"}
        onChange={(event) => {
            //Ensure Above Minimum of 1
            //Ensure Below or at Max Allowed By Game
            if(event.target.value > 1 && event.target.value <= gamesData.maxPlayersData[gameValue]){
                setMaxPlayersContest(event.target.value);
            }
        }}
        />
        </div>
    )

    return display;
  }

  const displayEntryFeeSelect = () => {
      let display = null;
      let entries = null;

        if(availableEntryFees) {
            entries = availableEntryFees.map((entryFee) => {
                return(
                    <option value={entryFee}>{entryFee} Credit</option>
                )
            })
        }

        if(entries !== null){
            let emptySelect = (
                <option value={0}> Please Select Entry Fee </option>
            )
            entries.unshift(emptySelect);

            display = (
                <React.Fragment>
                <InputLabel shrink>
                 Entry Fee (Credits)
                </InputLabel>
                <Select value={entryFeeValue}
                onChange={(event) => {
                    setEntryFeeValue(event.target.value);
                }}
                >
                    {entries}
                </Select>
                </React.Fragment>
            )
        }

      return display;
  }

  const displayAvailableGames = () => {
    let display = null;
    let displayEntries = null;

    

    if(availableGames !== null){

        displayEntries = availableGames.map( (availableGame) => {

            let tileStyle = null;

            if(availableGame.name === gameValue){
                tileStyle = {borderWidth: 1, borderColor: 'white', borderStyle: 'solid', marginLeft: 8, marginRight: 8, marginTop: 8};
            } else {
                tileStyle = {marginLeft: 8, marginRight: 8, marginTop: 8};
            }

            

             return (
                  <GridListTile key={availableGame.name}
                  style={tileStyle}
                  onClick={() => {
                      handleSetGameValue(availableGame.name);
                  }}
                  >
                   <img src={availableGame.image} />
                   <GridListTileBar
                    title={availableGame.name}
                    subtitle={`Top Score Afer A Pre-Determined Number Of Rounds`}
                    classes={{
                        root: classes.titleBar,
                        title: classes.title,
                    }}
                    actionIcon={
                        <IconButton aria-label={`star ${availableGame.name}`}>
                        <StarBorderIcon className={classes.title} />
                        </IconButton>
                    }
                    />
                </GridListTile>
             )
        })

    }

    if(displayEntries !== null){
        display = (
            <GridList className={classes.gridList} cols={2.5} style={{paddingLeft: '.7em', paddingRight: '.7em'}}>
                {displayEntries}
            </GridList>
        )
    }


    return display;
  }

  const handleSelectGoal = (_goal, _description) => {

    setGoal(_goal);
    setGoalDesc(_description);

  }

  const displayGameGoals = () => {
    let display = null;
    let displayEntries = null;

    let gameGoals = {};

    if(gameValue){
        
        

        for(let availableGame of availableGames){

            if(availableGame.name === gameValue){
            let goals = availableGame.contests;
                displayEntries = goals.map(goal => {
                    gameGoals[goal.id] = goal.description;
                    return (
                        <FormControlLabel value={goal.id} control={<Radio />} label={goal.description} />
                    )
                    
                })
            
            }

        }
    }
    if(displayEntries !== null){
        display = (
            <RadioGroup row aria-label="position" name="position" defaultValue="goal1" onChange={(event) => {
                //console.log('event', event, event.target.checked, event.target.value);
                console.log('goal', event.target.value, gameGoals[event.target.value]);
                handleSelectGoal(event.target.value, gameGoals[event.target.value]);
            }}>
            {displayEntries}
          </RadioGroup>
        )
    }
    

    return display;
  }

  const displayContestGames = () => {
      let display = null;

      let gameSelect = displayGamesSelect();
      let gameMaxPlayers = displayGameMaxPlayers();
      let contestMaxPlayers = displayContestMaxPlayers();
      let contestEntryFee = displayEntryFeeSelect();
      let gamingGoals = displayGameGoals();

      if(gameSelect !== null){

          display = (
            <Paper elevation={3} style={{marginTop: 8, marginLeft: 14, marginRight: 14, paddingTop: 8}}>
            <Typography variant="h5" className={classes.title}>
            Create A Gaming Contest 
            </Typography>
              <Grid container spacing={2} style={{marginTop: 8}}>
                <Grid item xs>
                    {gameSelect}
                    {gameMaxPlayers}
                </Grid>
                <Grid item xs>
                    {gamingGoals}
                </Grid>
                <Grid item xs>
                    {contestMaxPlayers}
                </Grid>
                <Grid item xs>
                    {contestEntryFee}
                </Grid>
                <Grid item xs>
                <Button
                onClick={() => {
                    attemptCreateContest();
                }}
                > Create Contest </Button>
                </Grid>
             </Grid>
              
              </Paper>
          )

      }

      return display;
  }

  return (
    <div>
    {displayAvailableGames()}
    {displayContestGames()}
    </div>
  )

}